import { useEffect } from "react";

// Lightweight SEO helper — no external dependency.
// Sets document title, meta description, canonical URL,
// and Open Graph + Twitter Card tags per page.
const SITE_URL = "https://soveu.nl";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

function setMeta(selector, attr, attrValue, content) {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, attrValue);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setLink(rel, href) {
  let tag = document.head.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
}

export default function SeoHead({ title, description, path, image }) {
  useEffect(() => {
    if (title) document.title = title;

    const canonicalPath =
      path ||
      (typeof window !== "undefined" ? window.location.pathname : "/");
    const canonical = `${SITE_URL}${canonicalPath === "/" ? "/" : canonicalPath}`;

    if (description) {
      setMeta('meta[name="description"]', "name", "description", description);
      setMeta(
        'meta[property="og:description"]',
        "property",
        "og:description",
        description
      );
      setMeta(
        'meta[name="twitter:description"]',
        "name",
        "twitter:description",
        description
      );
    }

    if (title) {
      setMeta('meta[property="og:title"]', "property", "og:title", title);
      setMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    }

    setLink("canonical", canonical);
    setMeta('meta[property="og:url"]', "property", "og:url", canonical);

    const imgUrl = image || DEFAULT_OG_IMAGE;
    setMeta('meta[property="og:image"]', "property", "og:image", imgUrl);
    setMeta('meta[name="twitter:image"]', "name", "twitter:image", imgUrl);
  }, [title, description, path, image]);

  return null;
}
